Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var PctyListColumn = function PctyListColumn(_ref) {
  var children = _ref.children,
      align = _ref.align,
      onClick = _ref.onClick,
      automationId = _ref.automationId,
      other = _objectWithoutProperties(_ref, ['children', 'align', 'onClick', 'automationId']);

  var otherProps = _extends({}, other, {
    className: ((other.className || '') + ' pcty-list-column pcty-type-' + align + 'align').trim(),
    'data-automation-id': automationId || null
  });

  return _react2.default.createElement(
    'td',
    _extends({}, otherProps, { onClick: onClick }),
    children
  );
};

PctyListColumn.propTypes = {
  children: _propTypes2.default.node.isRequired,
  /** Specifies the alignment of the column */
  align: _propTypes2.default.oneOf(['left', 'center', 'right']),
  /** A handler for the click event of the column */
  onClick: _propTypes2.default.func,
  /** A string that can be referenced by UI automation tools */
  automationId: _propTypes2.default.string
  /** INCLUDE OTHER */
};

PctyListColumn.defaultProps = {
  align: 'left',
  onClick: function onClick() {}
};

exports.default = PctyListColumn;